<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'paymentActions.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>

    <button [disabled]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right"
            (click)="addPaymentAction()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('paymentActions.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>

    <app-company-selection-list [ngClass]="companySelectionListClass" [active]="hasSelectCompanyPermission"
                                [hideLabel]="true" [selectCompanyText]="'users.selectCompanyPlaceHolder' | translate"
                                (companyChangedEvent)="handleCompanyChanged($event)">
    </app-company-selection-list>

    <input type='text' class="d-none d-xl-block form-control filter-input"
           placeholder="{{'paymentActions.filterByDescriptionPlaceHolder' | translate}}"
           (keyup)='searchFilter($event)'/>

  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'paymentActions.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let paymentAction of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <td class="d-none d-sm-table-cell">{{ paymentAction.CreatedAt | date:'d-M-y HH:mm:ss' }}</td>
          <td>{{ paymentAction.Title }}</td>
          <td class="d-none d-xl-table-cell">{{ paymentAction.CompanyName }}</td>
          <td>
            <a *ngIf="hasEditPaymentActionPermission" class="success"
               title="{{ 'paymentActions.editPaymentActionTitle' | translate }}"
               (click)="editPaymentAction(paymentAction)">
              <i class="ft-edit-2 font-medium-3"></i>
            </a>
            <a *ngIf="hasViewPaymentActionPermission" class="primary"
               title="{{ 'paymentActions.viewPaymentActionTitle' | translate }}"
               (click)="viewPaymentAction(paymentAction)">
              <i class="ft-eye font-medium-3"></i>
            </a>
            <a class="info" title="{{'paymentActions.sharePaymentActionUrlTitle' | translate}}"
               (click)="openCopyModal(paymentAction)">
              <i class="ft-link-2 font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="hasDeletePaymentActionPermission" class="danger"
               title="{{'paymentActions.deletePaymentActionTitle' | translate}}"
               (click)="deletePaymentAction(paymentAction)">
              <i class="ft-x font-medium-3 danger"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
